/** What a space is connected to: a channel, or a machine, each detachable on its own. */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import type { SpaceConnection } from "@nebulize/sdk";

import { api } from "@/lib/api";

export const connectionKeys = {
  of: (spaceId: string) => ["spaces", spaceId, "connections"] as const,
};

export function useConnections(spaceId: string): UseQueryResult<SpaceConnection[]> {
  return useQuery({
    queryKey: connectionKeys.of(spaceId),
    enabled: spaceId !== "",
    queryFn: () => api.get<SpaceConnection[]>(`/v1/spaces/${spaceId}/connections`),
  });
}

export function useDetachConnection(
  spaceId: string,
): UseMutationResult<undefined, Error, string> {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (connectionId: string) =>
      api.delete<undefined>(`/v1/spaces/${spaceId}/connections/${connectionId}`),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: connectionKeys.of(spaceId) });
    },
  });
}
